import React from 'react';
import { useTranslation } from '../App';

const Footer = () => {
  const t = useTranslation();
  return (
    <section className="footer">
      <div className="footer-content flex">
        <div className="foot-item foot-main">
          <h3>{t.footer.title}</h3>
          <p className="para">{t.footer.description}</p>
          <p>{t.footer.phone}</p>
          <p>{t.footer.email}</p>
          <p>{t.footer.address}</p>
          <a href="https://wa.me/+918851303071" className="foot-btn">
            {t.footer.button} <img src="/assets/icons/up-right-arrow.png" width="15px" alt="" />
          </a>
        </div>

        <div className="foot-item foot-link">
          <h4>{t.footer.mainPages}</h4>
          <a href="#home">{t.footer.pages.home}</a>
          <a href="#abt">{t.footer.pages.about}</a>
          <a href="#service">{t.footer.pages.service}</a>
          <a href="#project">{t.footer.pages.work}</a>
        </div>

        <div className="foot-item foot-link">
          <h4>{t.footer.socialLinks}</h4>
          <a href="https://www.instagram.com/">{t.footer.social.instagram}</a>
          <a href="#">{t.footer.social.facebook}</a>
          <a href="https://www.linkedin.com/in/">{t.footer.social.linkedin}</a>
          <a href="#">{t.footer.social.twitter}</a>
        </div>
      </div>
      <div className="copyright">
        <a href="">{t.footer.copyright}</a>
      </div>
    </section>
  );
};

export default Footer;
